import { NavItem } from '@/components/v2/Header/Header.types';

export const isLinkActive = (navItem: NavItem, pathname: string) =>
    navItem?.href === pathname ||
    navItem?.page === pathname ||
    (navItem?.children && navItem.children.find(childNavItem => childNavItem.href === pathname));
